import { useWizardPageContext } from '@components/containers/WizardPage/hooks/useWizardPageContext';
import { entityVariant } from '@components/Wizard/components/Subway/constants';
import { SubwayEntity } from '@components/Wizard/components/Subway/SubwayEntity';
import { useIsNewSubway } from '@components/Wizard/hooks/useIsNewSubway';
import { useWizardSubwaySection } from '@components/Wizard/hooks/useWizardSubwaySection';
import CampaignSectionSubwayOld from './CampaignSectionSubwayOld';
import { labels } from './constants';
import type { CampaignSectionGeneralProps } from './types';

const CampaignSectionSubway = (props: CampaignSectionGeneralProps) => {
  const isNewSubway = useIsNewSubway();
  const { campaign } = useWizardPageContext();
  const { active, setActiveSection } = useWizardSubwaySection({
    key: props.sectionKey,
    defaultPaneKey: labels.nameDates.value,
  });

  if (!isNewSubway) {
    return <CampaignSectionSubwayOld {...props} />;
  }

  return (
    <SubwayEntity
      {...campaign}
      status={campaign?.status ?? 'INACTIVE'}
      onClick={() => setActiveSection(props.sectionKey)}
      selected={active}
      sectionKey={props.sectionKey}
      title={campaign?.name}
      variant={entityVariant.campaign}
    />
  );
};

export default CampaignSectionSubway;
